export default "__VITE_ASSET__804307cc__"